import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "../../../../redux/store";
import { fetchDGCoinCategories } from "../../../../features/auth/store/dgcoinCategorySlice";
import DGCoinCategoriesTable from "./DGCoinCategoriesTable";
import { CreateDGCoinCategoryModal } from "../../Modal/DGCoins/CreateDGCoinCategoryModal";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { Button } from "../../../../components/Reusable/Button";
import { EditDGCoinCategoryModal } from "../../Modal/DGCoins/EditDGCoinCategoryModal";
import { DeleteDGCoinCategoryModal } from "../../Modal/DGCoins/DeleteDGCoinCategoryModal";

const DGCoinCategories: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);

  const { dgcoinCategories, loading, error } = useSelector(
    (state: RootState) => state.dgcoinCategories
  );

  useEffect(() => {
    dispatch(fetchDGCoinCategories({}));
  }, [dispatch]);

  const openDeleteModal = async (id: number) => {
    setSelectedCategory(id);
    setIsDeleteModalOpen(true);
  };

  const openEditModal = async (id: number) => {
    setSelectedCategory(id);
    setIsEditModalOpen(true);
  };

  const filteredCategories = dgcoinCategories.filter((category) => {
    const matchesStatus = !statusFilter || category.status === statusFilter;
    const matchesSearch =
      !searchTerm ||
      category.name.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="DG Coin Categories">
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-4 mb-4">
              <input
                type="text"
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border p-2 rounded"
              />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="border p-2 rounded"
              >
                <option value="">All Status</option>
                <option value="on">Active</option>
                <option value="off">Inactive</option>
              </select>
            </div>
            <Button
              onClick={() => setIsCreateModalOpen(true)}
              bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
              textColor="text-white"
              borderRadius="rounded-lg"
              className="w-[200px] h-10 ml-6"
            >
              New Category
            </Button>
          </div>

          <DGCoinCategoriesTable
            categories={filteredCategories}
            loading={loading}
            onDelete={openDeleteModal}
            onEdit={openEditModal}
          />

          <CreateDGCoinCategoryModal
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
          />

          <EditDGCoinCategoryModal
            isOpen={selectedCategory !== null && isEditModalOpen}
            id={selectedCategory}
            onClose={() => {
              setIsEditModalOpen(false);
              setSelectedCategory(null);
            }}
          />

          <DeleteDGCoinCategoryModal
            id={selectedCategory}
            isOpen={isDeleteModalOpen}
            onClose={() => {
              setIsDeleteModalOpen(false);
              setSelectedCategory(null);
            }}
          />
        </InternalContainer>
        {error && <p className="text-red-500 mt-2">{error}</p>}
      </div>
    </ExternalContainer>
  );
};

export default DGCoinCategories;
